(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-header"]) return;
  try {
    
  (function () {
    if (window.__tkHeaderInit) return;
    window.__tkHeaderInit = true;

    function openDrawer() {
      var drawer = document.getElementById('tk-mobile-drawer');
      var hamburger = document.getElementById('tk-hamburger');
      if (!drawer) return;
      drawer.hidden = false;
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      var drawer = document.getElementById('tk-mobile-drawer');
      var hamburger = document.getElementById('tk-hamburger');
      if (!drawer) return;
      drawer.hidden = true;
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    function toggleMobileSearch(forceState) {
      var wrap = document.getElementById('tk-mobile-search');
      var toggle = document.getElementById('tk-mobile-search-toggle');
      if (!wrap) return;
      var shouldOpen = typeof forceState === 'boolean' ? forceState : wrap.hidden;
      wrap.hidden = !shouldOpen;
      if (toggle) toggle.setAttribute('aria-expanded', String(shouldOpen));
      if (shouldOpen) {
        var input = wrap.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    }

    function closeAllMegaMenus(except) {
      document.querySelectorAll('.tk-nav__item--has-children.tk-open').forEach(function (item) {
        if (item !== except) {
          item.classList.remove('tk-open');
          var btn = item.querySelector('[data-tk-mega-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function closeAllIconDropdowns(except) {
      document.querySelectorAll('.tk-header__navitem.tk-open').forEach(function (item) {
        if (item !== except) {
          item.classList.remove('tk-open');
          var btn = item.querySelector('[data-tk-icon-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.addEventListener('click', function (event) {
      var hamburger = event.target.closest('#tk-hamburger');
      if (hamburger) {
        openDrawer();
        return;
      }

      if (event.target.closest('[data-tk-drawer-close]')) {
        closeDrawer();
        return;
      }

      var searchToggle = event.target.closest('#tk-mobile-search-toggle');
      if (searchToggle) {
        toggleMobileSearch();
        return;
      }

      var megaToggle = event.target.closest('[data-tk-mega-toggle]');
      if (megaToggle) {
        var item = megaToggle.closest('.tk-nav__item--has-children');
        var isOpen = item.classList.contains('tk-open');
        closeAllMegaMenus();
        if (!isOpen) {
          item.classList.add('tk-open');
          megaToggle.setAttribute('aria-expanded', 'true');
        } else {
          megaToggle.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      var iconToggle = event.target.closest('[data-tk-icon-toggle]');
      if (iconToggle) {
        var navitem = iconToggle.closest('.tk-header__navitem');
        var iconIsOpen = navitem.classList.contains('tk-open');
        closeAllIconDropdowns();
        if (!iconIsOpen) {
          navitem.classList.add('tk-open');
          iconToggle.setAttribute('aria-expanded', 'true');
        } else {
          iconToggle.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      if (!event.target.closest('.tk-nav__item--has-children')) {
        closeAllMegaMenus();
      }

      if (!event.target.closest('.tk-header__navitem')) {
        closeAllIconDropdowns();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.code === 'Escape') {
        closeDrawer();
        closeAllMegaMenus();
        closeAllIconDropdowns();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
